import { ReactNode } from 'react';
import styled from 'styled-components';

const StyledPageWrapper = styled.div`
@media(max-width: 767px) {
    padding-bottom: 9rem;
  }
`;

interface Props {
    children: ReactNode
};

const PageWrapper = ({children}: Props) => (

    <StyledPageWrapper>{children}</StyledPageWrapper>
);

export default PageWrapper;